"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _utils = require("../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Toggle =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Toggle, _PureComponent);

  function Toggle(props) {
    var _this;

    _classCallCheck(this, Toggle);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Toggle).call(this, props));

    _this.setWrapperRef = function (node) {
      _this.wrapperRef = node;
    };

    _this.handleOutsideClick = function (e) {
      if (!_this.wrapperRef.contains(e.target)) {
        _this.setState({
          on: false
        }, function () {
          return _this.props.onToggle(_this.state.on);
        });
      }
    };

    _this.toggle = function () {
      return _this.setState(function (_ref) {
        var on = _ref.on;
        return {
          on: !on
        };
      }, function () {
        _this.props.onToggle(_this.state.on);
      });
    };

    _this.capturedEvents = ['touchend', 'click'];
    _this.state = {
      on: props.on
    };
    _this.shouldHandleOutsideClick = props.offOnOutsideClick;
    return _this;
  }

  _createClass(Toggle, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.on !== prevProps.on) {
        this.setState({
          on: this.props.on
        });
      }

      if (this.shouldHandleOutsideClick) {
        if (!this.state.on) {
          this.removeEvents();
        } else {
          this.addEvents();
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeEvents();
    }
  }, {
    key: "getStateAndHelpers",
    value: function getStateAndHelpers() {
      return {
        on: this.state.on,
        toggle: this.toggle
      };
    }
  }, {
    key: "removeEvents",
    value: function removeEvents() {
      var _this2 = this;

      this.capturedEvents.forEach(function (event) {
        document.removeEventListener(event, _this2.handleOutsideClick, true);
      });
    }
  }, {
    key: "addEvents",
    value: function addEvents() {
      var _this3 = this;

      this.capturedEvents.forEach(function (event) {
        document.addEventListener(event, _this3.handleOutsideClick, true);
      });
    }
  }, {
    key: "render",
    value: function render() {
      return this.shouldHandleOutsideClick ? _react2.default.createElement("span", {
        ref: this.setWrapperRef
      }, this.props.children(this.getStateAndHelpers())) : this.props.children(this.getStateAndHelpers());
    }
  }]);

  return Toggle;
}(_react.PureComponent);

Toggle.defaultProps = {
  on: false,
  offOnOutsideClick: false,
  onToggle: _utils.noop
};
exports.default = Toggle;